import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Label } from 'semantic-ui-react';
import { FiAlertTriangle } from 'react-icons/fi';
import MediaQuery from 'react-responsive';

// Actions
import { resetTimesheetTimesheetEntriesAPIErrors as resetTimesheetEntriesAPIErrorsAction } from 'services/timesheetTimesheetEntriesAPIErrors/actions';

// Selectors
import { selectErrorUuids } from './selectors';

interface StateProps {
    uuids?: string[];
}

interface DispatchProps {
    resetTimesheetEntriesAPIErrors: Function;
}

type Props = StateProps & DispatchProps;

export class TimesheetTimesheetEntriesErrorsButton extends React.PureComponent<
    Props
> {
    componentWillUnmount(): void {
        const { resetTimesheetEntriesAPIErrors } = this.props;

        resetTimesheetEntriesAPIErrors();
    }

    handleClick = (): void => {
        const { uuids } = this.props;

        if (uuids && uuids.length) {
            // Find corresponding row and scroll to it
            const element = document.getElementById('content');
            const rowElement = document.getElementById(uuids[0]);
            const tableHeaderHeight = 36;
            if (element && rowElement) {
                element.scrollTo(0, rowElement.offsetTop - tableHeaderHeight);
            }
        }
    };

    render(): React.ReactElement | null {
        const { uuids } = this.props;

        if (!uuids || !uuids.length) return null;

        return (
            <MediaQuery minWidth={1025}>
                {matches => (
                    <Button
                        circular
                        icon
                        style={{
                            position: 'relative',
                            padding: 0,
                            background: 'transparent',
                            color: matches ? undefined : '#fff',
                            boxShadow: 'none',
                            marginLeft: 5
                        }}
                        onClick={this.handleClick}
                    >
                        <FiAlertTriangle
                            size="24"
                            style={{ verticalAlign: 'middle' }}
                        />
                        <Label circular color="red" floating size="mini">
                            {uuids.length}
                        </Label>
                    </Button>
                )}
            </MediaQuery>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    uuids: selectErrorUuids
});

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    {
        resetTimesheetEntriesAPIErrors: resetTimesheetEntriesAPIErrorsAction
    }
)(TimesheetTimesheetEntriesErrorsButton);
